import { render, staticRenderFns } from "./BiddingList.vue?vue&type=template&id=078093d6"
import script from "./BiddingList.vue?vue&type=script&lang=js"
export * from "./BiddingList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports